import { useState, useEffect } from "react";
import { ENTITYNAME, TOAST_TYPES } from "../../../../framework/constant/constant";
import * as API from '../../../../framework/API/api';
import { useTranslation } from "../../../../locale/useTranslation";
import IsShortMediaCollectionSelection from "../../../../framework/forms/IsShortMediaCollectionSelection";
import RoundButton from "../../../../framework/forms/helpercomponents/buttons/RoundButton";
import DeleteRoundButton from "../../../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmDeleteAlert } from "../../../../ConfirmAlert";
import ToastNotification from "../../../../components/ToastNotification";

const AttachMediaTab = (props) => {

    const { mediaEpisode } = props;

    const [showEdit, setShowEdit] = useState(false);
    const boxStyle = { margin: "10px 5px", padding: "10px", borderRadius: "10px", backgroundColor: "white", wordWrap: "break-word" }
    const headingStyle = { fontFamily: "Roboto", fontSize: "16px", fontWeight: "700", letterSpacing: "0.2px", lineHeight: "18px", color: "#191825", padding: "10px 0" }
    const tableDataStyle = { fontFamily: "Roboto", fontSize: "13px", fontWeight: "400", letterSpacing: "0.2px", lineHeight: "18px", color: "#3C4048", padding: "10px" }

    const lang = useTranslation();
    const [selectedAttachedMedia, setSelectedAttachedMedia] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, [mediaEpisode])

    const loadData = async () => {
        setLoading(true);
        let attachedMediaRes = await API.getData(ENTITYNAME.MediaEpisodeAttachMedia, { query: ['srcId', '=', mediaEpisode._id] });
        if (attachedMediaRes.success) {
            setSelectedAttachedMedia(attachedMediaRes.data.map(x => { return { ...x.attachedMedia, attachMediaId: x._id } }) ?? []);
        }
        setLoading(false);
    }

    const onClose = () => {
        setShowEdit(!showEdit);
    }

    const handleMediaSelect = async (newAttachedMedia) => {

        if (newAttachedMedia.length == 0) return;

        let attachedMedia = {
            attachedMedia: { _id: newAttachedMedia._id, SID: newAttachedMedia.SID, Title: newAttachedMedia.Title, AssetId: newAttachedMedia.AssetId, Duration: newAttachedMedia.Duration, Mam: newAttachedMedia.Mam, MediaCategory: newAttachedMedia.MediaCategory },
            srcId: mediaEpisode._id,
            entityName: 'mediaepisode'
        }

        let res = await API.saveData(ENTITYNAME.MediaEpisodeAttachMedia, attachedMedia);

        if (res.success) {
            setSelectedAttachedMedia([...selectedAttachedMedia, ...newAttachedMedia]);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }

    }


    const onDeleteAttachMedia = async (attachedMedia) => {
        var res = await API.deleteData(ENTITYNAME.MediaEpisodeAttachMedia, attachedMedia.attachMediaId, "_id");
        if (res.success) {
            setSelectedAttachedMedia(selectedAttachedMedia.filter(x => x._id != attachedMedia._id));
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    return (
        <>
            <div style={boxStyle}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 0, padding: 0 }}>
                    <h1 style={headingStyle}>Attach Media</h1>
                    <RoundButton icon={'link'} title={lang.attach_media_button_tooltip} onClick={onClose} />
                </div>
                {loading ? <div style={{ display: "flex", height: "200px", justifyContent: "center", alignItems: "center" }}>
                    <i className="fa fa-spinner fa-spin fa-xl " />
                </div> :
                    <div style={{ overflow: "auto" }}>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th style={{ width: "50px" }} scope="col"></th>
                                    <th scope="col">Asset ID</th>
                                    <th scope="col">Title</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedAttachedMedia?.map((attachedMedia, index) => {
                                    return (
                                        <tr key={index}>
                                            <td className="text-nowrap" style={tableDataStyle} ><DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => onDeleteAttachMedia(attachedMedia), () => { })} /></td>
                                            <td className="text-nowrap" style={tableDataStyle}>{attachedMedia?.AssetId}</td>
                                            <td className="text-nowrap" style={tableDataStyle}>{attachedMedia?.Title}</td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </div>
                }

            </div>

            {showEdit && <IsShortMediaCollectionSelection addButtonTitle={lang.select_button_text} title={lang.media_library_dialog_header} wherestatement={['MediaCategory.isLong', '=', true]} setDataList={handleMediaSelect} entityname={ENTITYNAME.MediaEpisode} closeForm={onClose} mode={'single'} width={"84vw"} height={"68vh"} />}
        </>
    )
}

export default AttachMediaTab;